import { ISubject } from 'components/ingestion/Utility'
import { atom } from 'infrastructure/state/jotai.wrapper'

export const selectedSubjectAtom = atom({
  subject_id: 0,
  subject_name: '',
  branches: [] as ISubject[],
})
